var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({staticClass:"elevation-0 ml-3",attrs:{"outlined":"","color":"primary","small":""},on:{"click":function($event){return _vm.buttonClicked()}}},'v-btn',_vm.$props,false),[_c('v-icon',{staticClass:"pr-1",attrs:{"small":""}},[_vm._v("mdi-plus-circle")]),_vm._v(" "+_vm._s(_vm.label))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }